import View from "../common/components/PopinKoboRedirect";
import components from "./components.js";
components.define("js-PopinKoboRedirect", View);